﻿import React from 'react';
import PropTypes from 'prop-types';

import theme from "./Header.module.scss";

const Header = ({
  weekPeriod = '0-0',
}) => (
  <header className={theme.Header}>
    <div>
      <h1>{`Week ${weekPeriod} Regimen`}</h1>
    </div>
  </header>
);

Header.propTypes = {
  weekPeriod: PropTypes.string,
};

export default Header;
